import { useTranslation } from "react-i18next";
import type { WorkflowStatisticsQuery } from "./models";

export function StatisticsSummary({ query }: { query: WorkflowStatisticsQuery | null | undefined }) {
    const { t } = useTranslation();
    if (!query) return null;
    const text = (key: string, fallback: string) => t(`workflowData.${key}`, { defaultValue: fallback });
    const period = query.period;
    return <dl>
        <div><dt>{text("countUnit", "Count unit")}</dt><dd>{query.metric === "notes" ? text("notes", "Notes") : text("instances", "Workflow instances (each workflow in a Note counts separately)")}</dd></div>
        <div><dt>{text("types", "Formal workflow types")}</dt><dd>{query.workflow_titles.join(", ") || text("allTypes", "All workflow types")}</dd></div>
        <div><dt>{text("period", "Period")}</dt><dd>{period.kind === "absolute" ? `${period.start} – ${period.end}` : `${t(`workflowData.period_${period.kind}`, { defaultValue: period.kind })} · ${period.count} ${t(`workflowData.unit_${period.unit}`, { defaultValue: period.unit })}`} · {query.timezone}</dd></div>
        <div><dt>{text("groupBy", "Group by")}</dt><dd>{t(`workflowData.group_${query.group_by}`, { defaultValue: query.group_by })}{query.include_empty_periods ? ` · ${text("includeZeros", "include empty periods")}` : ""}</dd></div>
    </dl>;
}
